export default __webpack_public_path__ + "static/media/bag-icon.81e76f9b.svg";